/**
 * `record_class` value molluskio stamps on served rows that are not building
 * permits — code enforcement, inspections, licences, admin records, …
 * (molluskio#5385). Deprecated in favour of the `non_building_record` tag
 * (molluskio#4504); still honoured so no row loses its badge. They are kept and
 * credited like every other record (search, counts, coverage); the class/tags
 * identify them.
 */
export const NON_BUILDING_RECORD_CLASS = 'non_building_excluded';
/**
 * Tag molluskio puts in `tags` on a served row that is not a building permit
 * (molluskio#4504). The primary signal: ~4.4M served rows carry it with a NULL
 * `record_class` (molluskio#6001).
 */
export const NON_BUILDING_TAG = 'non_building_record';
/** True only for the deprecated `non_building_excluded` record_class. */
export function isNonBuildingRecord(recordClass) {
    return recordClass === NON_BUILDING_RECORD_CLASS;
}
/**
 * Whether a served row is a non-building record: it carries the
 * `non_building_record` tag OR the deprecated `non_building_excluded`
 * record_class (molluskio#6001). NULL / missing fields count as "no".
 */
export function isNonBuilding(row) {
    return (row.tags ?? []).includes(NON_BUILDING_TAG) || isNonBuildingRecord(row.record_class);
}
//# sourceMappingURL=recordClass.js.map